import type { TextSizing } from '../types';

export const DEFAULT_TEXT_SIZE = 50;
export const DEFAULT_TEXT_MIN_SIZE = 28;
export const DEFAULT_TEXT_TARGET_CHARS = 12;
export const DEFAULT_CHAR_WIDTH = 0.5;

export function resolveLogoText(name: string): string {
  const resolved = name.trim();
  return resolved || 'Logo';
}

export function extractInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const letters = words
    .map((word) => word.match(/\p{L}/u)?.[0])
    .filter((letter): letter is string => Boolean(letter))
    .slice(0, 2)
    .join('')
    .toUpperCase();
  return letters || 'LL';
}

export function resolveTextSize(text: string, sizing: TextSizing): number {
  const normalized = text.replace(/\s+/g, ' ').trim();
  const length = normalized.length;
  if (length === 0) return sizing.baseSize;

  if (sizing.maxWidth != null) {
    const fitted = sizing.maxWidth / (length * sizing.charWidth);
    return clamp(fitted, sizing.minSize, sizing.baseSize);
  }

  const scale = Math.min(DEFAULT_TEXT_TARGET_CHARS / length, 1);
  return clamp(sizing.baseSize * scale, sizing.minSize, sizing.baseSize);
}

export function formatTextSize(value: number): string {
  const rounded = Math.round(value * 100) / 100;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2);
}

function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}
